import axios from '@/http.js';
export const PROJECT_MGT_TABLE = 'api/projects/pageList';
export const PROJECT_APPROVAL_TABLE = '/api/projects/applyList';
export const PROJECT_IMPORT = '/api/projects/import';
export default {
    addProject(formData){
        const url = 'api/projects/create';
        return axios.post(url, formData);
    },
    applyProject (param) {
        const url = 'api/projects/apply';
        return axios.post(url, param);
    },
    getProjectList () {
        const url = `api/projects`;
        return axios.get(url);
    },
    getLoginUserProjects (){
        const url = `api/projects/selectList`;
        return axios.get(url);
    },
    getAdminProjects () {
        const url = `api/projects/adminList`;
        return axios.get(url);
    },
    del (projectId) {
        const url = `api/projects/${projectId}`;
        return axios.delete(url);
    },
    save (data) {
        const url = 'api/projects';
        return axios.post(url, data);
    },
    update (projectId, name) {
        const url = 'api/projects';
        return axios.put(url, {id: projectId ,name: name});
    },
    review (id, reviewStatus) {
        const url = 'api/projects/review';
        return axios.put(url, {id ,reviewStatus});
    },
    getTestProject () {
        const url = `/api/projects/test`;
        return axios.get(url);
    },
    updateProjectSet(projectId, data){
        const url = '/api/projects/updateSettings';
        return axios.put(url, data, {headers: {projectId}});
    },
    switchToFree(projectId){
        const url = '/api/projects/updateSettings';
        return axios.put(url, {projectId}, {headers: {projectId}});
    },
    getSystemProjectList(projectId){
        const url = '/api/projects/sysAdminList';
        return axios.get(url);
    },
    getAdminProjectList() {
        return axios.get('/api/projects/adminList')
    }
}